<template>
    <div class="forum-cantainer">
        <van-nav-bar title="我的报名论坛" left-arrow @click-left="back"></van-nav-bar>

        <div class="content">
            <div class="list" v-for="item in forumList" :key="item.id">
                <div class="forum-content">
                    <router-link tag="div" :to="{ path: '/forumDetail', query: { id: item.forumId } }" class="forum-item">
                        <div class="forum-banner">
                            <img :src="item.photo" alt />
                        </div>
                        <div class="title">{{ item.title }}</div>

                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import httpRequest from '@/module_visitor/api/http.js';

export default {
    data() {
        return {
            payPrice: 0,
            forumList: [],
            bannerList: [],
            show: false,
        };
    },
    watch: {},
    components: {},
    methods: {
        back() {
            this.$router.go(-1);
        },

        getData() {
            httpRequest.get(`/api/forum/order`).then(res => {
                if (res.data.code == 200) {
                    this.forumList = res.data.data;
                }
            });
        },
    },
    created() {
        this.getData();
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixin.scss';

.forum-cantainer {
    width: 100%;
    min-height: 100vh;
    background: #f8f8f8;

    .content {
        .list {
            .forum-content {
                padding: 10px;

                .forum-item {
                    background: #fff;
                    padding: 20px;

                    .forum-banner {
                        border-radius: 10px;
                        overflow: hidden;

                        img {
                            width: 100%;
                            height: auto;
                        }
                    }

                    .title {
                        font-weight: bold;
                        padding: 4px 0;
                    }

                    .text {
                    }

                    .desc {
                        display: flex;
                        color: #777;
                        font-size: 24px;
                        padding: 4px 0;

                        .forum-time {
                        }

                        .forum-status {
                        }
                    }

                    .select {
                        display: flex;
                        justify-content: space-between;

                        a {
                            font-size: 24px;
                        }

                        .sign-up {
                            font-size: 24px;
                            display: inline-block;
                            padding: 10px 20px;
                            border-radius: 4px;
                            background: linear-gradient(90deg, rgba(47, 107, 244, 0.62) -2.04%, #2062f9 100%);
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
}
</style>